import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "./context/CartContext";
import { AgeGate } from "./components/AgeGate";
import { Navigation } from "./components/Navigation";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";

// Pages
import Home from "./pages/Home";
import Story from "./pages/Story";
import Shop from "./pages/Shop";
import Cart from "./pages/Cart";
import Contact from "./pages/Contact";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import Admin from "./pages/Admin";
import FindSaltStone from "./pages/FindSaltStone";
import CityOptions from "./pages/CityOptions";
import OnlineStores from "./pages/OnlineStores";
import CityStores from "./pages/CityStores";
import Discover from "./pages/Discover";

function App() {
  return (
    <div className="min-h-screen bg-[#050505]">
      {/* Noise texture overlay */}
      <div className="noise-overlay"></div>
      
      <BrowserRouter>
        <CartProvider>
          <AgeGate>
            <ScrollToTop />
            <Navigation />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/discover" element={<Discover />} />
                <Route path="/story" element={<Story />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/find" element={<FindSaltStone />} />
                <Route path="/find/:city" element={<CityOptions />} />
                <Route path="/find/:city/online" element={<OnlineStores />} />
                <Route path="/find/:city/stores" element={<CityStores />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </main>
            <Footer />
          </AgeGate>
        </CartProvider>
      </BrowserRouter>
      
      <Toaster 
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#0A0A0A',
            border: '1px solid rgba(212, 175, 55, 0.3)',
            color: '#F2F0E9',
          },
        }}
      />
    </div>
  );
}

export default App;
